import React from 'react'
import Navbar from '../navbar/Navbar'
import Footer from '../footer/Footer'
import ChatBot from '../chatbotforwhatsapp/ChatBot'
import WhatsappChat from '../whatsappchat/WhatsappChat'

const Layout = ({ children }) => {
  return (
    <div>
      <Navbar />
      <div className="content">
        {children}
      </div>
      <WhatsappChat />
      <ChatBot/>
      <Footer />
    </div>
  )
}

export default Layout
